import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Fingerprint, ArrowRight, Loader2, ChevronLeft } from "lucide-react";
import { useEmployeeAuth } from "../../context/EmployeeAuthContext";
import { getTenant } from "../../lib/tenant";

export default function EmployeeLogin() {
  const { login } = useEmployeeAuth();
  const navigate = useNavigate();
  const tenant = getTenant();
  const [empId, setEmpId] = useState("");
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const res = await login(empId.trim(), pin);
    setLoading(false);
    if (res.ok) navigate("/karyawan", { replace: true });
    else setErr(res.error);
  };

  const pinPad = (digit) => {
    if (digit === "del") setPin((p) => p.slice(0, -1));
    else if (pin.length < 8) setPin((p) => p + digit);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-slate-950 via-slate-900 to-indigo-950 px-5 py-8 text-white" data-testid="employee-login-page">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 shadow-lg shadow-orange-500/30">
            <Fingerprint size={30} className="text-slate-900" />
          </div>
          <h1 className="font-heading text-2xl font-bold">Portal HRD</h1>
          <p className="mt-1 text-sm text-slate-400">{tenant?.brand || tenant?.name || "Central Flow"} · Masuk dengan Employee ID & PIN</p>
          <button type="button" onClick={() => navigate("/login")} data-testid="emp-back-to-portal"
            className="mx-auto mt-3 flex items-center gap-1 text-xs text-slate-400 hover:text-white">
            <ChevronLeft size={14} /> Ganti perusahaan / portal
          </button>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-400">Employee ID</label>
            <input
              data-testid="emp-login-id"
              value={empId}
              onChange={(e) => setEmpId(e.target.value)}
              placeholder="EMP-0001"
              className="w-full rounded-xl border border-slate-700 bg-slate-800/60 px-4 py-3 text-base font-medium text-white placeholder-slate-500 outline-none focus:border-amber-400"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-400">PIN</label>
            <input
              data-testid="emp-login-pin"
              type="password" inputMode="numeric" value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
              placeholder="••••"
              className="w-full rounded-xl border border-slate-700 bg-slate-800/60 px-4 py-3 text-center text-2xl tracking-[0.5em] text-white placeholder-slate-600 outline-none focus:border-amber-400"
            />
          </div>

          {err && <p className="rounded-lg bg-red-500/15 px-3 py-2 text-center text-sm text-red-300" data-testid="emp-login-error">{err}</p>}

          <div className="grid grid-cols-3 gap-2.5">
            {["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "del"].map((d, i) => (
              d === "" ? <div key={i} /> : (
                <button type="button" key={i} onClick={() => pinPad(d)}
                  className="rounded-xl bg-slate-800/60 py-3 text-lg font-semibold text-white transition-colors hover:bg-slate-700 active:scale-95">
                  {d === "del" ? "⌫" : d}
                </button>
              )
            ))}
          </div>

          <button type="submit" disabled={loading || !empId || pin.length < 4}
            data-testid="emp-login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-amber-400 to-orange-500 py-3.5 font-bold text-slate-900 transition-all hover:shadow-lg hover:shadow-orange-500/30 disabled:opacity-40">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <>Masuk <ArrowRight size={18} /></>}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-slate-500">Demo: EMP-0001 · PIN 1234</p>
      </div>
    </div>
  );
}
